// extracted by mini-css-extract-plugin
module.exports = {"table":"UsersListComponent_table__37rib"};